import { Button, Flex, Layout, Modal, Table, Typography } from "antd";
import { PlusCircle } from "lucide-react";
import { CategoryForm } from "@components";
import { useState } from "react";
import { categoryTable } from "@configurations";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useGetCategories } from "@hooks";

export const CategoryPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {t} = useTranslation();
  const { data, isLoading } = useGetCategories();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Layout>
        <Flex justify="space-between" align="center">
          <div style={{display: 'flex'}}>
            <div
              style={{
                width: 3,
                backgroundColor: "#F1B80E",
                borderRadius: 100,
                marginRight: 12,
              }}
            />
            <Typography.Title level={2} style={{ margin: 0 }}>
            {t("categories")}
            </Typography.Title>
          </div>
          <Button
            type="primary"
            size="large"
            icon={<PlusCircle />}
            onClick={() => setIsModalOpen(true)}
          >
            {t("pages.category.newButton")}
          </Button>
        </Flex>

        <div
          style={{
            boxShadow: "rgba(0, 0, 0, 0.16) 1px 0px 10px",
            borderRadius: "8px",
            marginTop: 12,
          }}
        >
          <Table
            size="middle"
            dataSource={data}
            rowKey={(record) => record.id}
            loading={isLoading}
            style={{ borderRadius: "8px" }}
            columns={categoryTable}
          />
        </div>

        <Modal
          title= {t("pages.category.newButton")}
          open={isModalOpen}
          destroyOnClose
          footer={null}
          onCancel={() => setIsModalOpen(false)}
        >
          <CategoryForm setIsModalOpen={setIsModalOpen}/>
        </Modal>
      </Layout>
    </motion.div>
  );
};
